import React from 'react';
import copyToClipboard from 'copy-to-clipboard';
import _ from 'lodash';
import Moment from 'moment';
import { useFormikContext } from 'formik';
import { FormFieldProps, showToast } from '@rosenau/rosenau-ui';

export default <P extends FormFieldProps & {disabled?: boolean}>(Component: React.ComponentType<P>): React.FC<P> =>
    (props: P & {children: React.ReactNode}) => {
        const { children, disabled, inputGroupAppend, name, ...rest } = props;
        const { values } = useFormikContext();

        const componentProps = {
            disabled,
            inputGroupAppend: disabled ? <button type="button" className="btn text-muted" style={{backgroundColor: "#e9ecef", border: "1px solid #ced4da", padding: "0px 6px"}} onClick={() => {
                const value = _.get(values, name);

                let clipboardValue: string | undefined;

                if (typeof value === "string") {
                    clipboardValue = value;
                } else if (typeof value === "number") {
                    clipboardValue = value.toString();
                } else if (Moment.isDate(value)) {
                    clipboardValue = Moment(value).format("YYYY-MM-DD");
                } else if (Array.isArray(value)) {
                    clipboardValue = value.join(", ");
                }
    
                if (clipboardValue && clipboardValue !== "") {
                    copyToClipboard(clipboardValue, {
                        format: "text/plain",
                        onCopy: () => showToast("Copy to clipboard", "The value has been copied to your clipboard.", "success")
                    });
                } else {
                    showToast("Copy to clipboard", "No value to copy.", "danger")
                }
            }}><i className="material-icons" style={{fontSize: "18px"}}>file_copy</i></button> : inputGroupAppend,
            name,
            ...rest
        } as unknown as P;

        if (disabled) {
            return <Component {...componentProps}>{children}</Component>;
        } else {
            return <Component {...componentProps}>{children}</Component>;
        }
    }
